import { createSlice } from '@reduxjs/toolkit';
import axios from '../../services/authService';
import { API_ENDPOINTS } from '../../config/apiConfig';

const initialState = {
  regressionTestIds: [],
  loading: false,
  error: null,
};

export const getRegressionTestIdsSlice = createSlice({
  name: 'getRegressionTestIds',
  initialState,
  reducers: {
    reset: (state) => {
      state.regressionTestIds = [];
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setRegressionTestIds: (state, action) => {
      state.regressionTestIds = action.payload;
      state.loading = false;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { reset, setLoading, setRegressionTestIds, setError } =
  getRegressionTestIdsSlice.actions;

// Async thunk
export const getRegressionTestIdsAsync = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axios.get(API_ENDPOINTS.GET_REGRESSION_TEST_IDS);
    // Handle response - could be array directly or { data: [...] }

    const raw = response.data?.data || [];

    const activeIds = raw
      .filter((item) => item.is_active === 1)
      .map((item) => item.regression_test_id);

    dispatch(setRegressionTestIds(activeIds));
    return { success: true, data: activeIds };
  } catch (err) {
    const errorMessage =
      err.response?.data?.message || err.message || 'Failed to fetch regression test IDs';
    console.error('Error fetching regression test IDs:', errorMessage);
    dispatch(setError(errorMessage));
    return { success: false, error: errorMessage };
  }
};

// Selectors
export const selectRegressionTestIds = (state) => state.getRegressionTestIds.regressionTestIds;
export const selectRegressionTestIdsLoading = (state) => state.getRegressionTestIds.loading;
export const selectRegressionTestIdsError = (state) => state.getRegressionTestIds.error;

export default getRegressionTestIdsSlice.reducer;
